import styled from "styled-components";
import BREAKPOINTS from "../../globals/breakpoints";

const { lg } = BREAKPOINTS;

export const MainWrapper = styled.div`
  max-width: ${lg};
  margin: 0 auto;
`;

export const AppWrapper = styled.div``;
